export default "__VITE_ASSET__528661ee__"